export type Bonus = {
  title: string
  description: string
  value: string
  image?: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Quick Guide: Calm a Tantrum in 3 Steps',
    description:
      'The exact 3 steps to de-escalate a meltdown before it takes over your afternoon.',
    value: '$17 value',
    image: 'https://cdn.magicpatterns.com/uploads/brwWaMDCjyanS5ME9hG9YG/bonus_1.webp',
  },
  {
    title: 'Editable Custom Routine Checklist',
    description: 'Build a routine that matches your actual family, not a generic template.',
    value: '$17 value',
    image: 'https://cdn.magicpatterns.com/uploads/wSSpjvcot8e5jfbGKkxRCW/bonus_2.webp',
  },
  {
    title: 'Reward & Positive Behavior Boards',
    description: 'Turn good behavior into a game your kid wants to win.',
    value: '$12 value',
    image: 'https://cdn.magicpatterns.com/uploads/pwiVvLWjzkNsnUKN9w1SpK/bonus_3.webp',
  },
  {
    title: 'Mini Guide: Surviving Chaotic Mornings',
    description: 'For the mornings that go sideways before 7am.',
    value: '$12 value',
    image: 'https://cdn.magicpatterns.com/uploads/pLDhBaEs1WVgbNffzT1GBB/bonus_4.webp',
  },
  {
    title: 'Easy & Fun Recipes to Cook With Your Kids',
    description: 'Simple, healthy recipes that double as connection time.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/ddXpVraTfUQ1ge1a5Xeup3/bonus_5.webp',
  },
  {
    title: 'Break Your Kid Free From Screen Addiction',
    description: 'A practical guide to reclaiming your kid from phones and tablets.',
    value: '$19 value',
    image: 'https://cdn.magicpatterns.com/uploads/2Z44FFn3EUk6wmSkerHJcg/bonus_6.webp',
  },
  {
    title: 'Magic Stories for Positive Parenting',
    description: 'Bedtime stories that teach without lecturing.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/1z7WDSku1f8YhR1GLptuxo/bonus_7.webp',
  },
  {
    title: 'Short Stories for Raising Kids With Values',
    description:
      'Stories that build honesty, kindness and perseverance — one bedtime at a time.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/fnyEBsA76X5h8fD5wdPhwk/bonus_8.webp',
  },
  {
    title: 'The Power of Focus: 101 Tips for Kids With ADHD',
    description: "Build your kid's attention span, step by step.",
    value: '$19 value',
    image: 'https://cdn.magicpatterns.com/uploads/aEvSYT6XCmqe2boAZujkof/bonus_9.webp',
  },
  {
    title: "What I Wish I'd Known Before Becoming a Mom",
    description: 'The small, big truths nobody told me — that I want to give you today.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/tt6yDatUzuSrjo5gn2fvb2/bonus_10.webp',
  },
  {
    title: '10 Screen-Free Activities to Reconnect as a Family',
    description: "Simple games to reconnect without a phone in anyone's hand.",
    value: '$12 value',
    image: 'https://cdn.magicpatterns.com/uploads/2tFVuUswnc8mbLT8MU4guR/bonus_11.webp',
  },
  {
    title: '70 Daily Connection Ideas',
    description: 'Quick activities that strengthen your bond with your kid.',
    value: '$16 value',
    image: 'https://cdn.magicpatterns.com/uploads/8UbQKCdbdkjdjRMxm7qmTo/bonus_12.webp',
  },
]
